import { motion } from "framer-motion";
import { EASE } from "@/lib/motion";

export const Reveal = ({ children, delay = 0, y = 32, className = "", ...rest }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.9, delay, ease: EASE }}
    className={className}
    {...rest}
  >
    {children}
  </motion.div>
);
